import * as React from "react";
import { Box, styled } from "@mui/material";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import { SecondaryTab, StyledTabContainer } from "../../Components/CustomTab";
import SettingsSlidersIcon from "../../Components/Icons/SettingsSlidersIcon";
import { useNavigate } from "react-router-dom";
import { useBatteryInfo, useVehicleInfo } from "../../Pages/DigitalTwinV3/DigitalTwinContext";
import { encryptTheParams } from "../../Helper/QueryParams/EncryptDecrypt";
import { PrimaryTooltip } from "../../Components/StyledComponent";
import Cookies from "universal-cookie";
import AppCache from "../../Helper/Common/AppCache";

const AdvancedAnalyticsButtonWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    paddingRight: "16px",
});

const AdvancedAnalyticsButton = styled("button")({
    width: 34,
    height: 34,
    borderRadius: "50%",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
    padding: 0,
    outline: "none",
    boxShadow: "2px 2px 4px 0px #97979740",
    border: "none",
    "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: "50%",
        padding: "1.5px",
        background:
            "linear-gradient(186.62deg, #6D72F6 5.2%, #AEB0FA 62.25%, #EEEBFF 135.59%)",
        WebkitMask:
            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
    },
    "&:hover": {
        backgroundColor: "#EFF0FF",
        "&::before": {
            background:
                "linear-gradient(186.62deg, #4D44D8 5.2%, #AEB0FA 98.6%, #EEEBFF 135.59%)",
        },
    },
});

export default function DigitalTwinTabs({
    tabs = [],
    selectedTab,
    changeTheTab = () => { },
}) {
    const navigate = useNavigate();
    const [currentTab, setCurrentTab] = React.useState(selectedTab);
    const [hovered, setHovered] = React.useState(false);
    const { batteryID, showBusDeviceInfo, batteryInfo: { deviceID } } = useBatteryInfo();
    const vehicleInfo = useVehicleInfo();

    const cookies = new Cookies();
    const availablePages = AppCache.getItem("pages");

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
        changeTheTab(newValue);
    };

    React.useEffect(() => {
        setCurrentTab(selectedTab);
    }, [selectedTab]);

    const handleAdvancedAnalyticsClick = () => {
        let temp = {
            batteryID: batteryID,
            deviceID: deviceID,
            selectedType: 'deviceID',
            selectedTypeId: deviceID,
        };
        if (showBusDeviceInfo() && Object.keys(vehicleInfo).length > 0) {
            temp = {
                ...temp,
                selectedType: 'vehicle',
                selectedTypeId: vehicleInfo?.licensePlateNo
            }
        }
        encryptTheParams(temp, navigate, false, '/advanced-analysis', true);
    };

    return (
        <Box
            sx={{
                borderBottom: "1px solid #E6E6E6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <StyledTabContainer
                    value={currentTab}
                    onChange={handleChange}
                    aria-label="secondary tabs"
                    elevation={1}
                    myColor={ThemeProperties.purple}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        // Highlight the scroll arrows: theme-purple circular button
                        // with a rounded border so it's clearly visible. Fade only
                        // when disabled (nothing to scroll).
                        "& .MuiTabs-scrollButtons": {
                            color: "#6D72F6",
                            border: "1.5px solid #6D72F6",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            alignSelf: "center",
                            margin: "0 4px",
                            backgroundColor: "#F7F7FF",
                        },
                        "& .MuiTabs-scrollButtons svg": { fontSize: "1.3rem" },
                        "& .MuiTabs-scrollButtons.Mui-disabled": { opacity: 0.25 },
                    }}
                >
                    {tabs.map((item) => (
                        <SecondaryTab value={item.slug} key={item.id} label={item.name} />
                    ))}
                </StyledTabContainer>
            </Box>

            {availablePages.includes("AdvancedAnalysis") && (
                <AdvancedAnalyticsButtonWrapper>
                    <PrimaryTooltip title="Go to Advanced Analysis" position="bottom">
                        <AdvancedAnalyticsButton
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            onClick={handleAdvancedAnalyticsClick}
                        >
                            <SettingsSlidersIcon fill={hovered ? "#4D44D8" : undefined} width={18} height={18} />
                        </AdvancedAnalyticsButton>
                    </PrimaryTooltip>
                </AdvancedAnalyticsButtonWrapper>
            )}

        </Box>
    );
}
